export const FETCH_LOCATIONS = `LOCATIONS/FETCH_LOCATIONS`;
export const LOADING_LOCATIONS = `LOCATIONS/LOADING_LOCATIONS`;
export const SET_LOCATIONS = `LOCATIONS/SET_LOCATIONS`;
export const ADD_LOCATION = `LOCATIONS/ADD_LOCATION`;
export const EDIT_LOCATION = `LOCATIONS/EDIT_LOCATION`;
export const DELETE_LOCATION = `LOCATIONS/DELETE_LOCATION`;
export const UPDATE_LOCATIONS_SORTING = `LOCATIONS/UPDATE_LOCATIONS_SORTING`;
export const SET_DEFAULT_LOCATIONS_SORTING = `LOCATIONS/SET_DEFAULT_LOCATIONS_SORTING`;
export const UPDATE_LOCATION_FOR_SHARED_ROOM = `LOCATIONS/UPDATE_LOCATION_FOR_SHARED_ROOM`;
export const UPDATE_LOCATION_FOR_MANAGE_USERS = `LOCATIONS/UPDATE_LOCATION_FOR_MANAGE_USERS`;
